<template>
  <div class="user-agreement-page main_bg_color">
    <div class="agreement-container">
      <h2 class="agreement-title">用户协议</h2>
      <div class="agreement-content">
        <p>
          1、使用本公司网站的客户，请留意阁下所在的国家或居住地的相关法律规定，如有疑问应就相关问题，寻求当地法律意见。
        </p>
        <p>
          2、若发生遭黑客入侵破坏行为或不可抗拒之灾害等导致网站故障或资料损坏、资料丢失等情况，我将以本公司之后备资料为最后处理依据；为确保各方利益，请各会员投注后列印资料。本公司不会接受没有列印资料的投诉。
        </p>
        <p>
          3、为避免纠纷，各会员在投注之后，务必进入下注状况检查及列印资料。若发现任何异常，请立即与代理商联系查证，一切投注将以本公司资料库的资料为准，不得异议。如出现特殊网络情况或线路不稳定导致不能下注或下注失败，本公司概不负责。
        </p>
        <p>
          4、开奖结果以官方公布的结果为准，如官方开奖延迟或开奖结果更改的，本公司有权进行更正处理，不得异议。
        </p>
        <p>
          5、任何的投诉必须在开奖之前提出，本公司不会受理任何开奖之后的投诉。
        </p>
        <p>
          6、所有投注项目，公布赔率时出现的任何打字错误或非故意人为失误，本公司保留改正错误和按正确赔率结算投注的权力。
        </p>
        <p>
          7、开奖后的投注，将被视为
          “无效”。所有赔率将不定时浮动，派彩时的赔率将以确认投注时之赔率为准。
        </p>
        <p>
          8、如发生临时性、突发性等特殊情况，本公司有权作出相对应之决定，不得异议。
        </p>
        <p>
          9、本公司所有投注皆告本金，请认真了解协议说明。您在本公司网站下第一笔注单时，就代表您已同意及接受所有本公司的《用户协议》。
        </p>
        <p class="management-info">"666888" 管理层敬启</p>
      </div>
      <div class="button-group">
        <button class="btn plain" @click="cancel">不同意</button>
        <button class="btn primary" @click="agree">同意</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  mounted() {
    this.title = sessionStorage.getItem("title");
    this.$nextTick(function () {
      document.getElementsByTagName("meta")[0].content =
        "initial-scale=0.3,maximum-scale=1,minimum-scale=0.3,user-scalable=yes";
      console.log(document.getElementsByTagName("meta")[0]);
    });
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: "viewport",
          content:
            "initial-scale=0.3,maximum-scale=1,minimum-scale=0.3,user-scalable=yes",
        },
      ],
    };
  },
  methods: {
    agree() {
      this.$router.push("/index");
    },
    cancel() {
      this.$router.push("/");
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.user-agreement-page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 全局样式重置，可根据实际需求调整 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background-color: linear-gradient(135deg, #edefef, #ebedeb);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    font-family: Arial, sans-serif;
  }

  .agreement-container {
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .agreement-title {
    background: var(--new-bg-primary);
    color: var(--new-text-primary-bg);
    padding: 12px;
    text-align: center;
    font-size: 18px;
  }

  .agreement-content {
    padding: 16px;
    max-height: 400px;
    overflow-y: auto;
    line-height: 1.6;
    color: var(--new-text);
  }

  .management-info {
    text-align: right;
    margin-top: 10px;
    color: var(--new-text-info);
    font-size: 14px;
  }

  .button-group {
    display: flex;
    justify-content: center;
    padding: 12px 16px;
    background-color: var(--new-bg-table-header-main);
    border-top: 1px solid var(--new-border);
  }

  .btn {
    padding: 5px 10px;
    margin: 0 40px;
    width: 80px;
    margin-left: 10px;
  }

  // .disagree {
  //   background-color: #fff;
  //   color: #ff6600;
  //   border: 1px solid #ff6600;
  // }

  // .agree {
  //   background-color: #ff6600;
  //   color: #fff;
  // }
}
</style>
